import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";

import Home from "./Home";
import Services from "./Services";
import Blog from "./Blog";

import Contact from "./Contact";
import Aboutus from "./Aboutus";
import Products from "./Products";
import ProductDetails from "./ProductDetails";
import BlogDetail from "./BlogDetail";
import QRCodeGenerator from "./QRCodeGenerator";
import Error404 from "./Error404";
import ClientProjects from "./ClientProjects";
import AiTrendsGallery from "./components/AiTrendsGallery";
import PromptDetails from "./components/PromptDetails";

const RouterContainer = () => {
  const PageOpenFromTop = () => {
    const location = useLocation();
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location]);

    return null;
  };

  return (
    <>
      <BrowserRouter>
        <PageOpenFromTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/About-us" element={<Aboutus />} />
          <Route path="/Services" element={<Services />} />
          <Route path="/Blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogDetail />} />

          <Route path="/Contact" element={<Contact />} />
          <Route path="/Products" element={<Products />} />
          <Route path="/product/:id" element={<ProductDetails />} />
          <Route path="/QRCodeGenerator" element={<QRCodeGenerator />} />
          <Route path="/Projects" element={<ClientProjects />} />
          <Route path="/ai-content-studio" element={<AiTrendsGallery />} />
          <Route path="/ai-content-studio/prompt/:id" element={<PromptDetails />} />
          <Route path="*" element={<Error404 />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default RouterContainer;
